import { Snackbar } from "@mcleod/components";
import { CommonDialogs } from "@mcleod/common";
import { AutogenLayoutDOEFuelIndex } from "./autogen/AutogenLayoutDOEFuelIndex";
import { Api } from "@mcleod/core";

export class DOEFuelIndex extends AutogenLayoutDOEFuelIndex {

    buttonRetrieveDOEPricesOnClick() {
        this.buttonRetrieveDOEPrices.busy = true;
        Api.post("lme/general/refresh-fuel-prices")
            .then(() => {
                this.sourceFuelPrice.search();
                this.sourceFuelPriceMonthly.search();
                Snackbar.showSuccessSnackbar("DOE fuel prices retrieved.");
            })
            .catch((error) => CommonDialogs.showError(error, "Failed to retrieve DOE fuel prices"))
            .finally(() => {
                this.buttonRetrieveDOEPrices.busy = false;
            });
    }
}
